import { Typo3_834 } from '@/types'

export const checkIsCurrentChild = (
  item: string | undefined,
  pathname: string
) => {
  if (!item) {
    return false
  }
  return pathname.startsWith(item)
}

export const getActiveItem = (
  items: Typo3_834['navigation'],
  pathname: string
) => {
  if (pathname.split('/').length <= 2) {
    return null
  }

  const basePath = pathname.split('/').slice(0, 3).join('/')

  return items.find((item) => item.link?.startsWith(basePath))
}
